import React, { useCallback } from 'react';
import styled from 'styled-components';

import { Text, FlexView, Separator, COLORS } from '@cuemath/comps';

const GUTTER = 16;

const Wrapper = styled(FlexView)(
  () => `
  border-radius: ${GUTTER * 0.75}px;
  margin-bottom: ${GUTTER * 2}px;
  border:1px solid ${COLORS.GHOST};
`,
);

const Tag = styled(FlexView)(
  ({ color }) => `
border-top-left-radius: ${GUTTER * 0.75}px;
border-top-right-radius: ${GUTTER * 0.75}px;
background: ${color};
`,
);

function SchoolHelp({
  homeworkHelpConfig,
  testHelpConfig,
  homeWorkHelpReport,
  testHelpReport,
  studentData,
  ptmType,
}) {
  const { areas: hwConfigAreas } = homeworkHelpConfig || {};
  const { first_name: fname } = studentData || {};
  const {
    is_hw_help_provided: isHWHelpProvided,
    selected: selectedHomeWork = [],
    topics,
  } = homeWorkHelpReport || {};
  const { areas: testConfigAreas } = testHelpConfig || {};
  const {
    selected: selectedTest = [],
    performance,
    previous_performance: previousPerformance,
  } = testHelpReport || {};
  const isOnDemandPTM = ptmType === 'ON_DEMAND';

  const renderTestHelp = useCallback(() => {
    const { grade, scored, total } = performance || {};
    const { grade: prevGrade, scored: prevScored, total: prevTotal } =
      previousPerformance || {};

    return selectedTest.map((selectedTestIndex, idx) => {
      let statement = '';

      const testHelpArea = testConfigAreas[idx];
      const {
        report_statement: reportStatement,
        area_label: reportHeading,
        report_statement_with_performance: reportStatementWithPerformance = [],
        report_statement_with_previous_performance: reportStatementWithPrevPerformance = [],
      } = testHelpArea || {};

      if (!reportStatement) {
        return null;
      }

      if (selectedTestIndex || selectedTestIndex === 0) {
        if (
          isOnDemandPTM &&
          reportStatementWithPrevPerformance[selectedTestIndex] &&
          performance &&
          previousPerformance
        ) {
          statement = reportStatementWithPrevPerformance[selectedTestIndex]
            .replaceAll('<first_name>', fname)
            .replaceAll('<performance>', grade ? grade : `${scored}/${total}`)
            .replaceAll(
              '<previous_performance>',
              prevGrade ? prevGrade : `${prevScored}/${prevTotal}`,
            );
        } else if (reportStatementWithPerformance[selectedTestIndex] && performance) {
          statement = reportStatementWithPerformance[selectedTestIndex]
            .replaceAll('<first_name>', fname)
            .replaceAll('<performance>', grade ? grade : `${scored}/${total}`);
        } else if (reportStatement[selectedTestIndex]) {
          statement = reportStatement[selectedTestIndex].replace('<first_name>', fname);
        }
      }

      if (!statement) return null;

      return (
        <>
          <Text renderAs="cta2">{reportHeading}</Text>
          <Text renderAs="body2">{statement}</Text>
          <Separator height={GUTTER * 0.75} transparent />
        </>
      );
    });
  }, [fname, performance, selectedTest, testConfigAreas]);
  const getHWStatement = useCallback(() => {
    let statement = '';

    if (isHWHelpProvided === 1) {
      return hwConfigAreas[0].report_statement.replace('<first_name>', fname);
    }

    if (topics) {
      statement +=
        hwConfigAreas[1].report_statement
          .replace('<first_name>', fname)
          .replace('<topics>', topics) + ' ';
    }

    selectedHomeWork.forEach((item, idx) => {
      const hwHelpArea = hwConfigAreas[idx + 2] || {};
      const { report_statement: rStatement } = hwHelpArea || [];

      if (rStatement[item]) {
        statement += rStatement[item].replace('<first_name>', fname);
      }
    });

    return statement;
  }, [fname, hwConfigAreas, isHWHelpProvided, selectedHomeWork, topics]);

  const statementHwHelp = getHWStatement();

  return (
    <>
      {!!statementHwHelp && (
        <Wrapper>
          <Tag
            gutter={GUTTER * 0.75}
            gap={GUTTER / 2}
            alignItems="center"
            color={COLORS.GRASS_XXLIGHT}
          >
            <Text renderAs="eyebrow2">HOMEWORKS</Text>
          </Tag>
          <FlexView gutter={GUTTER * 0.75} gap={GUTTER * 0.75}>
            <Text renderAs="body2">{statementHwHelp}</Text>
          </FlexView>
        </Wrapper>
      )}

      <Wrapper>
        <Tag
          gutter={GUTTER * 0.75}
          gap={GUTTER / 2}
          alignItems="center"
          color={COLORS.SKY_XXLIGHT}
        >
          <Text renderAs="eyebrow2">TESTS</Text>
        </Tag>
        <FlexView gutter={GUTTER * 0.75} gap={GUTTER * 0.75}>
          {renderTestHelp()}
        </FlexView>
      </Wrapper>
    </>
  );
}

export default SchoolHelp;
